import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Router from 'router/router';
import * as Api from 'api/api';
import * as css from './css/footer';

function Footer(props) {
  const { className } = props;
  const [app, setApp] = useState(null);
  const [recordTime,setRecordTime] = useState("");

  useEffect(() => {
    const fetchInfo = async () => {
      const { info } = await Api.app();
      const recordTime = await Api.recordTime();
      setApp(info);
      setRecordTime(recordTime)
    };

    fetchInfo();
  }, []);

  return (
    <css.Footer className={className}>
      <css.Nav>
        <css.NavItem>
          <css.NavLink as={NavLink} to={Router.Home.path}>
            首页
          </css.NavLink>
        </css.NavItem>
        <css.NavItem>
          <css.NavLink as={NavLink} to=''>
            隐私保护
          </css.NavLink>
        </css.NavItem>
        <css.NavItem>
          <css.NavLink as={NavLink} to=''>
            联系我们
          </css.NavLink>
        </css.NavItem>
        <css.NavItem>
          <css.NavLink as={NavLink} to=''>
            免责条款
          </css.NavLink>
        </css.NavItem>
        <css.NavItem>
          <css.NavLink as={NavLink} to=''>
            公司简介
          </css.NavLink>
        </css.NavItem>
        <css.NavItem>
          <css.NavLink as={NavLink} to=''>
            商家入驻
          </css.NavLink>
        </css.NavItem>
        <css.NavItem>
          <css.NavLink as={NavLink} to=''>
            意见反馈
          </css.NavLink>
        </css.NavItem>
      </css.Nav>
      <css.CopyRight>
        <css.CopyRightText>
          © {recordTime} {app?.domain} 版权所有 {app?.websiteName}
        </css.CopyRightText>
      </css.CopyRight>
    </css.Footer>
  );
}

export default Footer;
